/* this file contains global utility functions to perform common tasks */
import axios from 'axios'
import Config from '@/config'
import store from '@/store'

axios.defaults.baseURL = Config.apiURL

export default {
  /**
 * returns data from an api request
 * @param {object} options = {
 *   method: {string}
 *   endpoint: {string},
 *   payload: {any}
 *   success(data)
 *   failure(data)
 * }
 *
 * @return {bool}
 */
  request (options) {
    return new Promise((resolve, reject) => {
      axios({
        method: options.method,
        url: options.endpoint,
        data: options.payload,
        headers: {
          Authorization: store.getters['person/authenticated'] ? store.getters['person/primaryPerson'].apiKey : false,
          proxyPerson: store.getters['person/proxyPerson'] ? store.getters['person/proxyPerson'].personID : 0
        }
      }).then((response) => {
        // hand over the data to the success handler
        if (options.success) {
          options.success(response.data)
        }
        resolve(response.data)
      }).catch((error) => {
        if (options.failure) {
          options.failure(error.data)
        }
        reject(error)
      })
    })
  }
}
